import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-filter-tag',
  templateUrl: './filter-tag.component.html',
  styleUrl: './filter-tag.component.scss',
})
export class FilterTagComponent implements OnInit{
  @Input() color = 'primary';
  @Input() bgColor = 'primary';
  @Input() icon = '';
  @Input() text: string;
  @Output() handleClick: EventEmitter<any> = new EventEmitter();
  @Input() chipSelected: boolean = false; // Flag to indicate whether the chip is selected

  toggleSelection(): void {
    this.chipSelected = !this.chipSelected; // Toggle the selected state of the chip
    this.handleClick.emit(this.chipSelected);
  }

  ngOnInit(): void {
  }
}
